var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8598 7.21293C18.0839 5.68888 17.8598 4.67285 17.0758 3.73497C16.2171 2.67986 14.649 2.25 12.6329 2.25H6.84598C6.43529 2.25 6.09928 2.56263 6.02461 2.99248L3.59782 19.0145C3.56049 19.3272 3.7845 19.6007 4.08318 19.6007H7.66735L7.40601 21.242C7.36867 21.5155 7.55535 21.75 7.85403 21.75H10.8782C11.2515 21.75 11.5502 21.4765 11.5875 21.1247L12.2222 16.9825C12.2596 16.6308 12.5956 16.3572 12.9316 16.3572H13.3796C16.2918 16.3572 18.6066 15.1067 19.2786 11.5115C19.5399 10.0266 19.4279 8.73697 18.6812 7.87725C18.4572 7.60371 18.1959 7.40832 17.8598 7.21293Z",
    fill: "#009CDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8598 7.21293C18.0839 5.68888 17.8598 4.67285 17.0758 3.73497C16.2171 2.67986 14.649 2.25 12.6329 2.25H6.84598C6.43529 2.25 6.09928 2.56263 6.02461 2.99248L3.59782 19.0145C3.56049 19.3272 3.7845 19.6007 4.08318 19.6007H7.66735L8.52606 13.8171C8.60073 13.3873 8.93675 13.0746 9.34743 13.0746H11.0649C14.425 13.0746 17.0385 11.6678 17.7852 7.52555C17.8225 7.44739 17.8225 7.33016 17.8598 7.21293Z",
    fill: "#012169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53411 7.252C9.57144 6.97846 9.90746 6.62675 10.2435 6.62675H14.7984C15.3211 6.62675 15.8437 6.66583 16.2918 6.74399C16.7025 6.82214 17.4492 7.01753 17.8225 7.252C18.0465 5.72796 17.8225 4.71192 17.0385 3.77405C16.2171 2.67986 14.649 2.25 12.6329 2.25H6.84598C6.43529 2.25 6.09928 2.56263 6.02461 2.99248L3.59782 19.0145C3.56049 19.3272 3.7845 19.6007 4.08318 19.6007H7.66735L9.53411 7.252Z",
    fill: "#003087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPaypal);
export default __webpack_public_path__ + "static/media/payment-paypal.156d10766b06346ffe405986f30ff803.svg";
export { ForwardRef as ReactComponent };